/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   recommendations helpers
 */

import { convertQueryStringToParams } from '@zcode/utils'
import getBrowserHistory from '../../../shared/utils/browserHistory'

export const getRecommIdQueryParam = () => {
  const history = getBrowserHistory()
  const { location } = history || {}
  const { search } = location || {}

  const queryObj = convertQueryStringToParams(search)
  const { recommId } = queryObj

  return recommId
}
